<template>
  <a-drawer width="86%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-collapse v-model="activeKey">
        <a-collapse-panel key="1" :header="$t('基础信息')" class="goods-collapse">
          <a-row>
            <a-col :span="10">
              <a-form-model-item prop="title" >
                <span slot="label" >
                <a-tooltip>
                {{$t('科普文章标题')}}<template slot="title">{{$t('科普文章标题')}}</template>
                </a-tooltip>
                </span>
                <a-input v-model="form.title" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('科普文章标题')" />
              </a-form-model-item>
            </a-col>

            <a-col :span="10">
              <a-form-model-item :label="this.$t('上级分类')" prop="categoryId" >
                <a-tree-select v-model="form.categoryId" style="width: 100%"
                               :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="cateOptions" :placeholder="this.$t('通用.文本.请选择')+this.$t('商品分类.上级分类')"
                               :replaceFields="{ children: 'children', title: 'name', key: 'id', value: 'id' }"
                               tree-default-expand-all>
                </a-tree-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item :label="'关键字'" prop="keyword"  >
                <a-input type="textarea" v-model="form.keyword"  :placeholder="$t('通用.输入.请输入')+$t('关键字,多个用英文逗号分割')"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-item :label="$t('是否推荐')" prop="isRecommend">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('是否推荐')" style="width: 100%"
                          v-model="form.isRecommend" >
                  <a-select-option v-for="(item, index) in isRecommend" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="18">
              <a-form-model-item :label-col="{span: 2}" :wrapper-col="{span: 20}" :label="$t('详情')" prop="description">
                <editor v-model="form.description" :placeholder="$t('通用.输入.请输入')+$t('详情')"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>



        <a-collapse-panel key="2" :header="$t('文章详情')" class="goods-collapse">


          <div v-for="(item, index) in dynamicItem" :key="index"  >
            <a-row>
              <a-col :span="8">
                <a-form-model-item prop="outline" >
                <span slot="label" >
                <a-tooltip>
                {{$t('大纲标题')}}<template slot="title">{{$t('科普文章大纲标题')}}</template>
                </a-tooltip>
                </span>
                  <a-input v-model="item.outline" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('科普文章标题')" />
                </a-form-model-item>
              </a-col>

              <a-col :span="8">
                <a-form-model-item :label="'关联科普文章'" prop="relatedPopularizeIds">
                  <a-select mode="multiple" v-model="item.relatedPopularizeIds" :placeholder="$t('通用.输入.请选择')+'关联科普文章'" allowClear
                            show-search
                            :filter-option="false"
                            @search="handlePopularizeSearch">
                    <a-select-option v-for="(popularizeItem, index) in popularizeOptions" :key="popularizeItem.id" :value="popularizeItem.id">
                      {{ popularizeItem.title }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>

                <a-col :span="8">
                  <a-form-model-item :label="$t('通用.文本.选择商品')" prop="goodsIds"  >
                    <a-button type="dashed" @click="openProdSelect(index)" danger>
                      <span style="color: dodgerblue"> {{$t('通用.文本.选择商品')}}</span>
                    </a-button>
                  </a-form-model-item>
                </a-col>

                <a-col :span="16">
                    <a-form-model-item :label="'已选商品'" prop="goodsIds">
                      <div style="border: 1px solid #d9d9d9; border-radius: 4px; padding: 8px; min-height: 36px;">
                        <a-tag
                          v-for="(goodsItem, gIdx) in item.goods.filter(g => g.id !== null)"
                          :key="goodsItem.id"
                          closable
                          color="blue"
                          style="margin-bottom: 4px;"
                          @close="removeGoods(index, gIdx)"
                        >
                          {{ goodsItem.goodsName }}
                        </a-tag>
                        <span v-if="item.goods.filter(g => g.id !== null).length === 0" style="color: #999; font-size: 12px;">
                          暂无商品
                        </span>
                      </div>
                    </a-form-model-item>
                </a-col>
              <a-col :span="18">
                <a-form-model-item :label-col="{span: 2}" :wrapper-col="{span: 20}" :label="$t('详情')">
                  <editor v-model="item.details" :placeholder="$t('通用.输入.请输入')+$t('详情')"/>
                </a-form-model-item>
              </a-col>
<!--                <a-col :span="8">-->
<!--                    <a-form-model-item :label="'图片'" prop="imgsUrl">-->
<!--                        <OssUploadSingle v-model="item.imgsUrl" type="img" :prefix="popu" :maxSize="200"></OssUploadSingle>-->
<!--                    </a-form-model-item>-->
<!--                </a-col>-->



<!--              <a-col :span="8">-->
<!--                <a-form-model-item :label="'视频'" prop="videoUrl">-->
<!--                  <OssUploadSingle v-model="item.videoUrl" type="video" :prefix="popu" :maxSize="200"></OssUploadSingle>-->
<!--                </a-form-model-item>-->
<!--              </a-col>-->
<!--              <a-col :span="8">-->
<!--                <a-form-model-item prop="content" >-->
<!--                <span slot="label" >-->
<!--                <a-tooltip>-->
<!--                {{$t('内容')}}<template slot="title">{{$t('内容')}}</template>-->
<!--                </a-tooltip>-->
<!--                </span>-->
<!--                  <a-input type="textarea" :rows="10" v-model="item.content"  :placeholder="$t('通用.输入.请输入')+$t('科普文章内容')" />-->
<!--                </a-form-model-item>-->
<!--              </a-col>-->
              <!-- 数据展示 -->

            </a-row>
            <a-row>
              <a-col :span="8">
                <a-button @click="deleteItem(item, index)" type="danger">删除大纲</a-button>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="30">
                ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
              </a-col>
            </a-row>
          </div>
          <a-row>
            <a-col :span="15">
              <a-button type="primary" @click="addItem" >
                <a-icon type="plus" />{{$t('增加大纲')}}
              </a-button>
            </a-col>

          </a-row>
        </a-collapse-panel>
      </a-collapse>


      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <radio-goods-select-form ref="RadioGoodsSelectForm" @goodsSelect="indexGoodsModalSelect"></radio-goods-select-form>

  </a-drawer>

</template>

<script>
import { getPopularize, addPopularize, updatePopularize, listPopularize } from '@/api/popularize/popularize'
import RadioGoodsSelectForm from "@/views/goods/goods/modules/RadioSelectForm";
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject, uploadOss} from "@/api/tool/oss";
import {listAllPopularizeCategory, listPopularizeCategory} from "@/api/popularize/popularizeCategory";
import OssUploadSingle from "@/components/OssUploadSingle";
import Editor from "@/components/Editor";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor,
    OssUploadSingle,
    CustomDictTag,
    RadioGoodsSelectForm,
  },
  data () {
    return {
      index:null,
      index1:null,
      goodsName:null,
      dynamicItem:[{
        id: null,
        outline: "",
        content: "",
        details:"",
        imgsUrl: "",
        videoUrl: "",
        goods: [{
          id: null,
          goodsName: null
        }],
        relatedPopularizeIds: []
      }],
      activeKey: [1, 2],
      popularizeOptions: [],
      cateOptions: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      isRecommend:[
          {
            type: 1,
            name: '是'
          },
          {
            type: 0,
            name: '否'
          }
      ],
      // 表单参数
      form: {
        id: null,
        title: null,
        categoryId: null,
        categoryLevel: null,
          keyword: null,
        isRecommend: 0,
        description: null,
          img: null,
          video: null,
          content: null,
        createTime: null,
        popularizeDetails:null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {

  },
  methods: {
    handlePopularizeSearch(value) {
      if (value) {
        listPopularize({ title: value }).then(response => {
          this.popularizeOptions = response.data || []
        })
      } else {
        this.getPopularizeList()
      }
    },
    indexGoodsModalSelect(records) {
      console.log('商品选择了', records[0])
      const record = records[0]
      this.form.goodsList = records
      console.log('下标', this.index1)
      const currentGoods = this.dynamicItem[this.index1].goods
      // 去重：检查是否已存在相同id的商品
      const exists = currentGoods.some(g => g.id === record.id)
      if (exists) {
        this.$message.warning('该商品已添加，请勿重复选择')
        return
      }
      // 如果第一条是空占位数据（id为null），则替换掉
      if (currentGoods.length === 1 && currentGoods[0].id === null) {
        currentGoods[0] = {
          id: record.id,
          goodsName: record.goodsName
        }
      } else {
        currentGoods.push({
          id: record.id,
          goodsName: record.goodsName
        })
      }
      console.log('商品选择11了', this.dynamicItem[this.index1])
    },
    // 移除单个商品
    removeGoods(itemIndex, goodsIndex) {
      this.dynamicItem[itemIndex].goods.splice(goodsIndex, 1)
      // 如果全部删光了，补一个空占位数据以保持结构
      if (this.dynamicItem[itemIndex].goods.length === 0) {
        this.dynamicItem[itemIndex].goods.push({
          id: null,
          goodsName: null
        })
      }
    },
    openProdSelect(index) {
      this.index1=index
      console.log('打开商品选择框,单选模式')
      this.$refs.RadioGoodsSelectForm.openGoods(undefined, [this.form.businessId]);
    },
    uploadIndex(index){
      console.log(22222222,index)
      this.index=index
    },
    deleteItem (item, index) {
      this.dynamicItem.splice(index, 1)
    },
    addItem () {
      this.dynamicItem.push({
        outline: "",
        content: "",
        details: "",
        imgsUrl: "",
        videoUrl: "",
        goods: [{
          id: null,
          goodsName: null
        }],
        relatedPopularizeIds: []
      })
    },

    getCateList() {
      /*这个方法是树的写法*/
      listAllPopularizeCategory().then(response => {
        const cate = { id: "0", name: this.$t('通用.文本.根节点'), children: [] }
        cate.children = this.handleTree1(response.data, 'id','parentId')
        this.cateOptions.push(cate)
      })
    },
    getPopularizeList() {
      listPopularize({}).then(response => {
        this.popularizeOptions = response.data || []
      })
    },
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.cateOptions= []
      this.formType = 1
      this.index=null
      this.index1=null
      this.goodsName=null
      this.dynamicItem=[
        {
          id: null,
          outline: "",
          content: "",
          details: "",
          imgsUrl: "",
          videoUrl: "",
          goods: [{
            id: null,
            goodsName: null
          }]
        }, {
          id: null,
          outline: "",
          content: "",
          details: "",
          imgsUrl: "",
          videoUrl: "",
          goods: [{
            id: null,
            goodsName: null
          }]
        }, {
          id: null,
          outline: "",
          content: "",
          details: "",
          imgsUrl: "",
          videoUrl: "",
          goods: [{
            id: null,
            goodsName: null
          }]
        }, {
          id: null,
          outline: "",
          content: "",
          details: "",
          imgsUrl: "",
          videoUrl: "",
          goods: [{
            id: null,
            goodsName: null
          }]
        }, {
          id: null,
          outline: "",
          content: "",
          details: "",
          imgsUrl: "",
          videoUrl: "",
          goods: [{
            id: null,
            goodsName: null
          }]
        }, {
          id: null,
          outline: "",
          content: "",
          details: "",
          imgsUrl: "",
          videoUrl: "",
          goods: [{
            id: null,
            goodsName: null
          }]
        }, {
          id: null,
          outline: "",
          content: "",
          details: "",
          imgsUrl: "",
          videoUrl: "",
          goods: [{
            id: null,
            goodsName: null
          }]
        },
        {
          id: null,
          outline: "",
          content: "",
          details: "",
          imgsUrl: "",
          videoUrl: "",
          goods: [{
            id: null,
            goodsName: null
          }]
        },{
          id: null,
          outline: "",
          content: "",
          details: "",
          imgsUrl: "",
          videoUrl: "",
          goods: [{
            id: null,
            goodsName: null
          }]
        },{
          id: null,
          outline: "",
          content: "",
          details: "",
          imgsUrl: "",
          videoUrl: "",
          goods: [{
            id: null,
            goodsName: null
          }]
        },
        {
          id: null,
          outline: "",
          content: "",
          details: "",
          imgsUrl: "",
          videoUrl: "",
          goods: [{
            id: null,
            goodsName: null
          }]
        }
      ]

      this.form = {
        id: null,
        title: null,
          content: null,
        description: null,
          img: null,
          video: null,
          keyword: null,
        isRecommend: 0,
        categoryId: null,
        categoryLevel: null,
        createTime: null,
        popularizeDetails:null
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.getCateList();
      this.getPopularizeList();
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.getCateList();
      this.getPopularizeList();
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPopularize({"id":id}).then(response => {
        console.log("response.data",response.data)
        this.form = response.data
        this.dynamicItem=response.data.popularizeDetails
        this.open  = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            this.form.popularizeDetails=this.dynamicItem
            updatePopularize(this.form).then(response => {
              this.$message.success(
                  message,
                  3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            this.form.popularizeDetails=this.dynamicItem
            addPopularize(this.form).then(response => {
              this.$message.success(
                  message,
                  3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      } else {
        this.handleImagePreview(file);
      }
    },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'live'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          console.log("333333==",_this.index)
          _this.$set(_this.dynamicItem[_this.index], 'imgsUrl', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    popuImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'live'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'img', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    // oss 上传结束


    handleTree1 (data, id, parentId, children, rootId) {
      id = id || 'id'
      parentId = parentId || 'parentId'
      children = children || 'children'
      rootId = rootId || Math.min.apply(Math, data.map(item => { return item[parentId] })) || '0'
      // 对源数据深度克隆
      const cloneData = JSON.parse(JSON.stringify(data))
      // 循环所有项
      const treeData = cloneData.filter(father => {
        var branchArr = cloneData.filter(child => {
          // 返回每一项的子级数组
          return father[id] === child[parentId]
        })
        if (branchArr.length > 0) {
          father.children = branchArr
          father.selectable = false;
        } else {
          father.children = []
        }
        // 返回第一层
        return father[parentId] == rootId
      })
      // return treeData !== '' ? treeData : data
      if(treeData === '' || treeData.length === 0) {
        return data
      }else{
        return treeData
      }
    }
  }
}
</script >
<style lang="less">
.goods-collapse > .ant-collapse-header {
  color: #007ffd !important;
  background: #e8eef9;
}
</style>